<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>


    <div class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-char05">
                <label class="label-caption">Vistoria</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(objView.id) }}</div>
            </div>

            <div class="form-item-char20">
                <label class="label-caption">Protocolo</label>
                <div class="field-label field-label-center">{{ objView.protocolo }}</div>
            </div>            

            <div class="form-item-char10">
                <label class="label-caption">Data</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtvistoria) }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Estabelecimento</label>
                <div class="field-label">{{ objView.nmestabelecimento }}</div>
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Nro SIM</label>
                <div class="field-label">{{ objView.nrosim }}</div>
            </div>

            <div class="form-item-char40">
                <label class="label-caption">Responsável</label>
                <div class="field-label">{{ objView.nmresponsavel }}</div>
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item-char20">
                <label class="label-caption">Início vistoria</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateTimeFromJson(objView.dhinicio) }}</div>
            </div>

            <div class="form-item-char20">
                <label class="label-caption">Encerramento vistoria</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateTimeFromJson(objView.dhencerramento) }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Atividade</label>
                <div class="field-label">{{ objView.nmatividade }}</div>
            </div>
        </div>
        

        <div class="row row-space">
            <div class="form-item-char40">
                <label class="label-caption">SIM</label>
                <div class="field-label">{{ objView.nmsim }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Fiscal</label>
                <div class="field-label">{{ objView.nmvistoriador }}</div>
            </div>
        </div>



        <div v-if="lsItens.length > 0" class="row row-space">
            <div
                v-for="item in lsItens"
                :key="item.id"
                class="form-item"
            >
                <label class="label-caption">{{ item.codigo }}</label>
                <div class="field-label field-label-center" :class="getClass(item.resultado)">{{ item.resultado }}</div>
            </div>
        </div>
        
        
        <div class="row-end">
            <button type="button" class="btn-small" @click="visualizarLaudo">Laudo</button>
            <button type="button" class="btn-small" @click="listarImagens">Fotos</button>
            <button type="button" class="btn-small" @click="onClickEmail">Email</button>
            <button type="button" class="btn-small" @click="closeForm">Retornar</button>
        </div>
    </div>
    

    <div v-if="lsNc.length>0" class="table-wrapper">
        <table>
            <thead><tr>
                <th>Ítem</th>
                <th>Prazo</th>
                <th>Status</th>
                <th>Previsão</th>
                <th>Correção</th>
            </tr></thead>
            <tbody>
                <tr v-for="(obj, index) in lsNc" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                    <td class="col-width-char10 center">{{ obj.ref_cditem }}</td>
                    <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(obj.dtprazo) }}</td>
                    <td class="col-width-char50">{{ obj.nmstatus }}</td>
                    <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(obj.acdtprevista) }}</td>
                    <td>{{ obj.acdetalhamento }}</td>
                </tr>
            </tbody>
        </table>
    </div>


    <DialogOkModal 
        v-if="showOkModal" 
        :message="msgOkModal" 
        @close="showOkModal=false" 
        @confirmed="showOkModal=false"
    />


    <EmailLaudoModal
        v-if="showEmailModal"
        @close="showEmailModal = false"
        @confirm="enviarEmailLaudo"
    />
    

    <ModalImagem v-model:show="showImageModal">
        <div v-if="currentImage">
            <img :src="`data:image/jpeg;base64,${currentImage.fname}`" :alt="currentImage.xtipo" class="modal-image">
            <button @click="nextImage">Próxima Imagem</button>
        </div>
    </ModalImagem>
</template>


<script setup>
import { computed, onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import DialogOkModal from '@/components/modals/DialogOkModal.vue';
import EmailLaudoModal from '@/components/modals/EmailLaudoModal.vue';
import ModalImagem from '@/components/utils/ModalImagem.vue';

const emit = defineEmits(['close']);
const props = defineProps({idView: {type: Number, default: 0}});

const currentImageIndex = ref(0);
const isLoading = ref(false);
const lsImagens = ref([]);
const lsNc = ref([]);
const lsItens = ref([]);
const msgAlerta = ref(null);
const msgOkModal = ref(null);
const objView = ref({});
const showEmailModal = ref(false);
const showImageModal = ref(false);
const showOkModal = ref(false);


const closeForm = () => {emit('close');}


async function enviarEmailLaudo(payload){
    try {
        msgAlerta.value = null;
        isLoading.value = true;
        showEmailModal.value = false;

        await Api.genericPost('/pla/vistoria/email', {
            id: objView.value.id,
            strparam1: payload.usarEnvolvidos ? '' : payload.emails
        });
        msgOkModal.value='Email adicionado a fila de envios!';
        showOkModal.value=true;

    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


function getClass(value) {
    if (!value) return ''; // protege contra undefined
    switch (value) {
        case 'CF': return 'cf';
        case 'CR': return 'cr';
        case 'NC': return 'nc';
        case 'NA': return 'na';
        default: return '';
    }
}

const getImagem = async(idAnexo) => {
    try{
        const dados = {id: idAnexo, strparam1: '1'};
        const req = await Api.genericPost('/lspla/pla06_anexo_base64', dados);
        return req.anexo;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;}
}


async function lerDados() {
    try{
        msgAlerta.value=null;
        isLoading.value = true;
        const req = await Api.genericPost('/listas/vistorias', {idep: globalStore.idep, id: props.idView});
        Object.assign(objView.value, req[0]);

        const reqItens = await Api.genericPost('/listas/vistorias/itens', {idreferencia: props.idView})
        lsItens.value = reqItens;
        
        const reqNC = await Api.genericPost('/dados/rac_nc', {
            idep: globalStore.idep,
            idreferencia: props.idView,
            strparam1: 'VISTORIA'});
        lsNc.value = reqNC;

    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value = false;}
}


const listarImagens = async() => {
    try{
        msgAlerta.value=null;
        isLoading.value = true;
        const req = await Api.genericPost('lspla/pla06_anexos', {id: props.idView, tipo: 1});
        if (req.length == 0){
            msgAlerta.value= 'Vistoria não possui imagens anexadas';
        }else{
            for (const img of req) {
                img.fname = await getImagem(img.id); // Fetch base64 string and store it in fname
            }
            lsImagens.value = req;
            currentImageIndex.value = 0;
            showImageModal.value = true;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
}

const nextImage = () => {
    if (currentImageIndex.value < lsImagens.value.length - 1){
        currentImageIndex.value++;
    }else{
        showImageModal.value = false;
    }
}


const currentImage = computed(() => lsImagens.value[currentImageIndex.value]);


function onClickEmail(){
    msgAlerta.value = null;
    showEmailModal.value = true;
}


async function visualizarLaudo() {
    try {
        msgAlerta.value = null;
        isLoading.value = true;

        const r = await Api.genericPost('/operacoes/solicitar/download', { id: objView.value.idlaudo });

        if (r.bolok === 1 && r.download_url) {
            window.open(r.download_url, '_blank');
        } else {
            msgAlerta.value = `ATENÇÃO: ${r.erro || 'Não foi possível abrir o anexo.'}`;
        }
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


onMounted(lerDados)
</script>